
















import {Vue, Component, Watch } from 'vue-property-decorator';
import { DateTime } from 'luxon';
import { dateInOriginalOffset, formatDate} from '@common/dateTimeHelper';
import MainTable from "./components/tables/MainTable.vue";

import SegmentControl from "@share/common/segment/Segment.vue";

import { MScheduleService } from "./MeetingsScheduleService";
import { SegmentDataItem } from '@share/common/segment/SegmentData';
import { MScheduleDataLoader } from './DataLoader';
import { MScheduleDataStorage } from './DataStorage';
import { SlotInteractionService, SlotInteractionServiceInterface } from './helpers/SlotInteractionService'

import { MeetingsSlotFabric } from './helpers/MeetingsSlotFabric';
import { SignalRHelper } from "./helpers/SignalRHelper";
import { RepositoryFabric } from '@api/repositories/RepositoryFabric';
import { RealtimeRepository } from '@api/repositories/reatime-repository/RealtimeRepository';

@Component({
    name: 'MeetingsSchedule',
    components: { SegmentControl, MainTable }
})
export default class MeetingsScheduleRoot extends Vue {

    manager: MScheduleService | null = null;
    slotInteractionService: SlotInteractionServiceInterface | null = null;

    created() {
        this.manager = new MScheduleService(
            new MScheduleDataLoader(this.$repositories, this.$store.getters['groupFilter']),
            new MScheduleDataStorage(),
            new MeetingsSlotFabric(),
            new SignalRHelper(this.$repositories.get(RepositoryFabric.REALTIME) as RealtimeRepository, this.lang),
            this.$store,
            {
                isAdmin: this.isAdmin,
                routeScheduleId: this.$route.params.scheduleId,
                userId: this.userId
            }
        );

        this.slotInteractionService = new SlotInteractionService(this.$repositories, this.$store);
    }

    destroyed() {
        this.manager?.destroy();
    }

    setSchedule(scheduleId: string) {
        this.manager?.setSelectedSchedule(scheduleId)
    }

    get segmentData(): SegmentDataItem[] {

        return this.rootSchedules?.map((schedule) => {
            return {
                active: this.currentSchedule === schedule.id,
                title: this.getFormatedDate(schedule.from as DateTime),
                value: schedule.id
            }
        }) || [];
    }

    getFormatedDate(date: DateTime) {
        const today = dateInOriginalOffset(DateTime.local(), this.offset);
        return formatDate(date, this.lang, date?.hasSame(today, 'year'))
    }

    @Watch("currentSchedule")
    watchCurrentSchedule(scheduleId: string) {
        if(scheduleId !== this.$route.params.scheduleId) {
            this.$router.push({ params:  {...this.$route.params, scheduleId} })
        }
    }

    private get rootSchedules() {
        return this.manager?.rootSchedules;
    }

    private get currentSchedule() {
        return this.manager?.selectedSchedule;
    }

    private get lang() {
        return this.$store.state.session.language ?? 'en';
    }

    private get offset() {
        return this.$store.state.timeZoneOffset;
    }

    private get isAdmin(): boolean {
      return this.$store.getters['isAdmin'];
    }

    private get userId() {
        return this.$store.state.session.userId;
    }
}
